import { Box } from "@mui/material";
import RouteProfilePopover from "./route-profile-popover";

const ChipList = ({ items }) => {
  if (!items?.length) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {items.map((item) => (
        <Box
          key={item.code}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 1.5,
            py: 0.3,
            borderRadius: "999px",
            backgroundColor: "rgba(0,0,0,0.06)",
            fontSize: "0.75rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          {item.name}
        </Box>
      ))}
    </Box>
  );
};

export const RoutingProfileColumns = [
  {
    accessorKey: "name",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Name</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>{row.original.name ?? "N/A"}</div>
    ),
  },
  {
    accessorKey: "selectionStrategy",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>Selection Strategy</div>
    ),
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.selectionStrategy ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "Precedence",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Precedence</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.precedence ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "routingTypes",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Routing Types</div>,
    cell: ({ row }) => <ChipList items={row.original.routingTypes} />,
  },
  {
    accessorKey: "processors",
    header: () => <div>Processors</div>,
    cell: ({ row }) => <ChipList items={row.original.processors} />,
  },
  {
    accessorKey: "cardTypes",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Card Types</div>,
    cell: ({ row }) => <ChipList items={row.original.cardTypes} />,
  },
  {
    accessorKey: "isActive",
    header: () => <div>Status</div>,
    cell: ({ row }) => {
      const isActive = row.original.isActive;
      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: isActive ? "#f0fdf4" : "#fef2f2",
            color: isActive ? "#15803d" : "#dc2626",
            fontSize: "0.8rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor: isActive ? "#16a34a" : "#dc2626",
            }}
          />
          {isActive ? "Active" : "Inactive"}
        </Box>
      );
    },
  },
  {
    id: "actions",
    header: () => <div>Actions</div>,
    cell: ({ row }) => (
      <RouteProfilePopover
        profile={row.original}
        onView={(profile) => console.log("view", profile)}
      />
    ),
  },
];
